<template>
  <div class="download-results">   
    <b-button id="download-results-btn" 
      class="mx-2"        
      @click="downloadResults"> 
    <i class="fa fa-download" aria-hidden="true"></i>    
     {{hebrew ? 'הורדה' : 'Download'}}
    </b-button>
    <dicta-dropdown
      @change="val => $store.commit('SET_FILE_FORMAT',  val)"
      :value="formatValue"
      :options="hebrew ? heFormatOptions : formatOptions"
      class="d-dropdown"
    ></dicta-dropdown>       
  </div>
</template>

<script>
function gtag() { window.dataLayer.push(arguments) }
export default {
  name: 'DownloadResults',
  data() {
    return {
      formatOptions: [ 'UD Format', 'BGU Format'],
      heFormatOptions: ['פורמט BGU', 'פורמט UD']
    };
  },
  computed: {
    hebrew () {
      return this.$settings.hebrew
    },    
    tsvFile () {
      return this.$store.state.results[0].BGU
    },
    udFile () {
      return this.$store.state.results[0].UD
    },
    selectedFormat () {
      return this.$store.state.fileFormat.includes('UD') ? this.udFile : this.tsvFile
    },
    udFormat () {
      return this.hebrew ? 'פורמט UD' : 'UD Format'
    },
    bguFormat () {
      return this.hebrew ? 'פורמט BGU' : 'BGU Format'
    },    
    formatValue: {
      get () {
        return this.$store.state.fileFormat.includes('UD') ? this.udFormat : this.bguFormat
      },  
      set (value) {
        this.$store.commit('SET_FILE_FORMAT',  value)
      }    
    }    
  },
  methods: {
    downloadResults() {      
      var downloadLink = document.createElement("a");
      var blob = new Blob(["\ufeff", this.selectedFormat]);
      var url = URL.createObjectURL(blob);
      downloadLink.href = url;
      if (this.$store.state.fileFormat.includes('UD')) {
        downloadLink.download = 'MorphologyResults.ud.tsv'
        gtag('event', 'Download UD Format')
      }  
      else {
        downloadLink.download = 'MorphologyResults.tsv.tsv'
        gtag('event', 'Download tsv Format')
      }  
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  
</style>
